import styled from '@emotion/styled';
import { KizenTypography } from '__app/typography';
import { shadowOverlay } from 'app/colors';
import { borderRadii } from 'app/spacing';
import { STEP_CARD_WIDTH } from 'pages/AutomationEngine/Engine/Steps/constants';

export const PLACEHOLDER_CARD_HEIGHT = 98;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  width: ${STEP_CARD_WIDTH}px;
  height: ${PLACEHOLDER_CARD_HEIGHT}px;
  ${shadowOverlay};
  background: var(--color-background-light);
  // border: 1px dashed var(--color-border-medium);
  border-radius: ${borderRadii.small};
`;

export const Body = styled.div`
  padding: 0 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  overflow-wrap: break-word;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  display: -webkit-box;
`;

export const StyledPlaceholder = styled.svg`
  overflow: hidden;
  border-radius: ${borderRadii.standard};
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
`;

export const RelativeKizenTypo = styled(KizenTypography)`
  position: relative;
`;
